import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import {
    SetOwnerDialogBody, SetOwnerDialogBodyProps, SetOwnerDialogState
} from '~src/spacesPlatform/components/content/SetOwnerDialog';
import { SearchSuggestionsService } from '~src/spacesPlatform/services/SearchSuggestionsService';

import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { Databases } from '../resources/Databases';
import { Tables } from '../resources/Tables';
import { sendContactModifiedTelemetry } from './CatalogChangeContactActionsTelemetry';

export namespace CatalogChangeContentActions {

  export function confirmChangeContact(externalContentType: string, externalContentItem: IContentInfo): Promise<IResult> {

    let externalContentService: Databases | Tables;
    if (externalContentType === 'database') {
      externalContentService = Databases;
    } else {
      externalContentService = Tables;
    }

    let currentContactId: string = null;
    if (externalContentItem.contact) {
      currentContactId = externalContentItem.contact.id;
    }

    const modalInstance = openReactActionDialog<SetOwnerDialogBodyProps, SetOwnerDialogState, IResult>({
      title:  Messages.changeContact(),
      bodyComponent: SetOwnerDialogBody,
      initialBodyProps: {
        prompt: Messages.changeContactPrompt({ CONTENT_NAME: L10n.elideIfLong(externalContentItem.name) }),
        showCredentialsWarning: false,
        isAdmin: false,
        isOwner: false,
        getQuery: (matchText: string) => SearchSuggestionsService.usersWithoutGuest(matchText)
      },
      initialDialogState: { targetOwner: null },
      actionName: Messages.changeContactConfirm(),
      action: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => {
        return externalContentService.setContact(({
          contactId: dialogState.targetOwner.id,
          contactType: 'User',
          ids: [externalContentItem.vizportalId],
        })).then((result: IResult) => {
          // Emit the PFT event only on success so the catalog-ui and vpc halves of the same
          // contact_modified.completed Juno schema have consistent "success" semantics.
          // displayToastForResult uses the same errors-array check for the success toast.
          if (!result?.errors || result.errors.length === 0) {
            sendContactModifiedTelemetry(externalContentType, externalContentItem);
          }
          displayToastForResult(result, Messages.changeContactError({ CONTENT_NAME: externalContentItem.name }),
          Messages.changeContactSuccess({ CONTACT_NAME: dialogState.targetOwner.displayName }));
          return result;
        });
      },
      actionDisabled: (_bodyProps: SetOwnerDialogBodyProps, dialogState: SetOwnerDialogState) => dialogState.targetOwner == null || dialogState.targetOwner.id === currentContactId,
      dialogWidth: TabDialogWidth.width500px,
      dismissDialogOnActionFailed: false,
    });

    return modalInstance.result as Promise<IResult>;
  }

  function displayToastForResult(result: IResult, errorMessage: string, successMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      ToasterService.instance.pop({
        type: ToastType.Error,
        text: errorMessage
      });
    } else {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}
